// ═══════════════════════════════════════════════════════════════════
//  composants/CrudHeader.js
//  CrudHeader
// ═══════════════════════════════════════════════════════════════════

import { THEME } from "../socle/theme";
import { btnBack, btnPrimary } from "./styles";

// petit en-tête réutilisable pour les modules CRUD
export function CrudHeader({ onBack, title, onAdd, addLabel }) {
  return (
    <div style={{display:"flex",alignItems:"center",gap:12}}>
      <button onClick={onBack} style={btnBack}>← Documents</button>
      <h2 style={{color:THEME.text,fontSize:18,fontWeight:800,margin:0}}>{title}</h2>
      <button onClick={onAdd} style={{marginLeft:"auto",...btnPrimary}}>{addLabel}</button>
    </div>
  );
}
